import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup } from 'react-bootstrap';

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <ButtonGroup size="sm" className="ms-3">
            <Button
                variant={i18n.language.startsWith('es') ? 'primary' : 'outline-primary'}
                onClick={() => changeLanguage('es')}
            >
                ES
            </Button>
            <Button
                variant={i18n.language.startsWith('en') ? 'primary' : 'outline-primary'}
                onClick={() => changeLanguage('en')}
            >
                EN
            </Button>
        </ButtonGroup>
    );
};

export default LanguageSelector;
